/**
 * Helper used by non-landing pages (Blog, Impressum, Datenschutz) to
 * navigate back to the landing page and optionally scroll to a section.
 *
 * Because the app uses state-driven routing (not react-router), the page
 * that renders the section (`LandingPage`) must mount before we can
 * scroll to `#features` et al. We wait two animation frames plus a tiny
 * timeout to let React commit and the CSS settle, then smooth-scroll.
 *
 * @param closeCurrentView Callback that unmounts the current non-landing view
 * @param sectionHash      Optional `#section-id` to scroll to after landing mounts
 */
export function navigateToLanding(
  closeCurrentView: () => void,
  sectionHash?: string,
): void {
  const targetUrl = sectionHash ? `/${sectionHash}` : '/';
  window.history.pushState({}, '', targetUrl);
  closeCurrentView();

  if (sectionHash) {
    // Double RAF + timeout: wait for React commit + layout.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          document.querySelector(sectionHash)?.scrollIntoView({ behavior: 'smooth' });
        }, 60);
      });
    });
  } else {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }
}
